import React from "react";

import { LightTooltip } from "components/Tooltip";

import { ReactComponent as CollapseSidebarIcon } from "assets/images/sideMenu/collapse-sidebar-icon.svg";

import { ListItemButton, Typography } from "../SideMenuItem/styles";

interface SideMenuToggleButtonProps {
  isCollapsed: boolean;
  onCollapseClick: () => void;
}

const SideMenuToggleButton: React.FC<SideMenuToggleButtonProps> = (props) => {
  const { isCollapsed, onCollapseClick } = props;

  const toggleButtonContent = (
    <ListItemButton
      onClick={onCollapseClick}
      isCollapsed={isCollapsed}
      selected={false}
      isActive={false}
      data-testid="side-menu-toggle-button"
    >
      <CollapseSidebarIcon
        style={{ transform: isCollapsed ? "rotate(180deg)" : "none" }}
      />
      <Typography variant="body2" isCollapsed={isCollapsed} isActive={false}>
        Згорнути панель
      </Typography>
    </ListItemButton>
  );

  if (!isCollapsed) {
    return toggleButtonContent;
  }

  return (
    <LightTooltip title="Розгорнути панель" placement="right">
      {toggleButtonContent}
    </LightTooltip>
  );
};

export default SideMenuToggleButton;
